import React from 'react';
import { Tab, TabController, Tabs } from '@one-thd/sui-atomic-components';
import { string, number, bool } from 'prop-types';
import QuotesTabPanels from './QuotesTabPanels';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import { triggerAnalyticsCustomEvent } from '../../utils/analyticsEvents';

const QuotesTabsView = ({
  maxListSize,
  componentId,
  isMobile
}) => {
  const {
    selectedTab,
    setSelectedTab,
    activeQuotes,
    expiredQuotes
  } = useQuoteContext();

  const TabsView = ({ variant }) => {
    const selectedTabOnChange = (_event, newValue) => {
      triggerAnalyticsCustomEvent('quotes.interaction-click', {
        component: `${newValue} quotes tab`,
      });
      setSelectedTab(newValue);
    };

    return (
      <TabController value={selectedTab}>
        <Tabs
          value={selectedTab}
          onChange={selectedTabOnChange}
          aria-label="Quotes status tabs"
          variant={variant}
        >
          <Tab label={`Active (${activeQuotes.length})`} value="active" />
          <Tab label={`Expired (${expiredQuotes.length})`} value="expired" />
        </Tabs>
        <QuotesTabPanels
          activeQuotes={activeQuotes}
          expiredQuotes={expiredQuotes}
          maxListSize={maxListSize}
          componentId={componentId}
          isMobile={isMobile}
        />
      </TabController>
    );
  };

  TabsView.propTypes = {
    variant: string.isRequired
  };

  return (
    <>
      { isMobile ? (
        <div>
          <TabsView variant="fullWidth" />
        </div>
      )
        : (
          <div>
            <TabsView variant="standard" />
          </div>
        )}
    </>
  );
};

QuotesTabsView.propTypes = {
  maxListSize: number,
  componentId: string,
  isMobile: bool
};
QuotesTabsView.defaultProps = {
  maxListSize: 3,
  componentId: '',
  isMobile: false
};
export default QuotesTabsView;
